export default class SessionManager {

    GetSessionData (sessionName) {

        const state = sessionStorage.getItem(sessionName);
        return state === null ? null : JSON.parse(state);

    }

    SetSessionData (sessionName, data) {

        sessionStorage.setItem(
            sessionName,
            JSON.stringify(data)
        );

    }

}
